import React from "react";
import { Container, Grid, Box, Typography } from "@mui/material";
import ComplaintsList from "../components/complaints/ComplaintsList";

const ClientAdminComplaints = () => {
  return (
    <Grid
      container
      rowSpacing={1}
      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      sx={{
        background: "#f4f4f4",
        paddingTop: "16px",
      }}
    >
      <Grid item xs={12} md={12}>
        <Container
          maxWidth="xl"
          sx={{
            bgcolor: "#fff",
            padding: "16px !important",
            borderRadius: "10px",
             width: "100%",
              minWidth: "100%",
          }}
        >
          <Typography
            sx={{ fontWeight: 700, textAlign: "center", mb: 2 }}
            variant="h5"
          >
            Complaints
          </Typography>
          <Box
            sx={{
              bgcolor: "#fff",
              height: {
                xs: "auto",
                md: "100%",
              },
              border: "1px solid #d1cfcf",
              borderRadius: "5px",
              padding: "4px 12px",
              paddingBottom: "50px",
            }}
          >
            <ComplaintsList />
          </Box>
        </Container>
      </Grid>
    </Grid>
  );
};

export default ClientAdminComplaints;
